export const getRandomId = (name = "") => {
  return `${name}${Math.random()}`
}
